exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".check-groups .list > li input,\n.check-groups .list > li label {\n  cursor: pointer;\n}\n", ""]);

